define('models/shared/user/user',['backbone',
    "models/shared/lookups/systext",
    "models/shared/user/role_collection",
    "models/shared/user/roleaccess_collection",
    "models/shared/securityquestions/securityquestion_collection",
    "models/shared/settings/settingvalue_collection",
], function (Backbone, SystemText, Roles, RolesAccess, SecurityQuestions, SettingValues) {
    var User = Backbone.Model.extend({

        url: function () {
            return this.instanceURL;
        },
        defaults: function () {
            emailRequired: true;
            emailConfirmRequired: true;
            lastNameRequired: true;
            firstNameRequired: true;
            passwordRequired: true;
            passwordConfirmRequired: true;
            zipCodeRequired: false;
            genderRequired: true;
            phonrnumberRequired: false;
            ssnRequired: false;
            dobRequired: false;
        },

        initialize: function (options) {
            options = options || {};
            this.instanceURL = options.instanceURL;

            this.UserGUID = options.UG;
            this.MemberStatusID = options.MSID;
            this.MemberStatus = options.MS;
            this.PrefixID = options.PID;
            this.Gender = options.G;
            this.Title = options.T;
            this.FirstName = options.FN;
            this.MiddleName = options.MN;
            this.LastName = options.LN;
            this.SSN = options.SSN;
            this.SuffixID = options.SID;
            this.EmailType = options.ET;
            this.Email = options.E;
            this.EmailVerified = options.EV;
            this.Password = options.PD;
            this.AddressLine1 = options.A1;
            this.AddressLine2 = options.A2;
            this.City = options.C;
            this.State = options.S;
            this.StateID = options.STID;
            this.StateAbbreviation = options.SA;
            this.ZipCodeID = options.ZID;
            this.ZipCode = options.Z;
            this.CountryID = options.CID;
            this.PhoneNumber = options.PH;
            this.ShortDescription = options.SD;
            this.Description = options.D;
            this.PhotoURL = buildImageURL(pf.enums.entityTypeCodeEnum.User, options.UG, pf.enums.imageTypeGUIDEnum.Thumbnail, options.PU);
            this.TimeZoneID = options.TZID;
            this.LastLoginDT = options.LLDT;
            this.CreatedDT = options.CDT;
            this.ReferredByUserID = options.RUID;
            this.notifications = options.N;
            this.network = options.NT;
            this.IsEditable = options.IE;
            this.Primary = options.P;
            this.DOB = options.DOB;
            this.SSN = options.SSN;
            this.Mobile = options.MBL;
            this.Roles = new Roles(options.AR, { parse: true });
            this.RolesAccess = new RolesAccess(options.ARA, { parse: true });
            this.SecurityQuestions = new SecurityQuestions(options.SQ, { parse: true });
            this.HasChanged = options.HC;
            this.UserSettingAttributes = new SettingValues(options.USA, { parse: true });
            this.CIPStatus = options.CIPS;
            this.CardType = options.CT;
            this.SSN4 = options.SSN4;
            this.ZipCodeLive = options.ZCL;
            this.SMS = options.SMS;
            this.OIWP = options.OIWP;
            this.Eligibility = options.EL;
            this.CipStatusId = options.CIPSID;
            this.UserStatusId = options.USID;
            this.isFinRegCipRequired = options.isFinRegCipRequired;
        },
        parse: function (data) {
            var response = {};
            if (data != null) {
                response.UserGUID = data.UG;
                response.MemberStatusID = data.MSID;
                response.MemberStatus = data.MS;
                response.PrefixID = data.PID;
                response.Gender = data.G;
                response.Title = data.T;
                response.FirstName = data.FN;
                response.MiddleName = data.MN;
                response.LastName = data.LN;
                response.SuffixID = data.SID;
                response.SSN = data.SSN;
                response.EmailType = data.ET;
                response.Email = data.E;
                response.EmailVerified = data.EV;
                response.Password = data.PD;
                response.AddressLine1 = data.A1;
                response.AddressLine2 = data.A2;
                response.City = data.C;
                response.State = data.S;
                response.StateAbbreviation = data.SA;
                response.StateID = data.STID;
                response.ZipCodeID = data.ZID;
                response.ZipCode = data.Z;
                response.CountryID = data.CID;
                response.PhoneNumber = data.PH;
                response.ShortDescription = data.SD;
                response.Description = data.D;
                response.PhotoURL = buildImageURL(pf.enums.entityTypeCodeEnum.User, data.UG, pf.enums.imageTypeGUIDEnum.Thumbnail, data.PU);
                response.TimeZoneID = data.TZID;
                response.LastLoginDT = data.LLDT;
                response.CreatedDT = data.CDT;
                response.ReferredByUserID = data.RUID;
                response.notifications = data.N;
                response.network = data.NT;
                response.IsEditable = data.IE;
                response.Primary = data.P;
                response.Roles = new Roles(data.AR, { parse: true });
                response.RolesAccess = new RolesAccess(data.ARA, { parse: true });
                response.SecurityQuestions = new SecurityQuestions(data.SQ, { parse: false });
                response.HasChanged = data.HC;
                response.DOB = data.DOB;
                response.Mobile = data.MBL;
                response.UserSettingAttributes = new SettingValues(data.USA, { parse: false });
                response.CIPStatus = data.CIPS;
                response.CardType = data.CT;
                response.SSN4 = data.SSN4;
                response.ZipCodeLive = data.ZCL;
                response.SMS = data.SMS;
                response.OIWP = data.OIWP;
                response.Eligibility = data.EL;
                response.CipStatusId = data.CIPSID;
                response.UserStatusId = data.USID;
                response.isFinRegCipRequired = data.isFinRegCipRequired;
            }
            return response;
        },
        save: function (attributes, options) {
            options = options || {};
            attributes = attributes || {};;

            var data = {};
            data.UG = this.attributes.UserGUID;
            data.MSID = this.attributes.MemberStatusID;
            data.MS = this.attributes.MemberStatus;
            data.PID = this.attributes.PrefixID;
            data.G = this.attributes.Gender;
            data.T = this.attributes.Title;
            data.FN = this.attributes.FirstName;
            data.MN = this.attributes.MiddleName;
            data.LN = this.attributes.LastName;
            data.SSN = this.attributes.SSN;
            data.SID = this.attributes.SuffixID;
            data.ET = this.attributes.EmailType;
            data.E = this.attributes.Email;
            data.EV = this.attributes.EmailVerified;
            data.PD = this.attributes.Password;
            data.A1 = this.attributes.AddressLine1;
            data.A2 = this.attributes.AddressLine2;
            data.C = this.attributes.City;
            data.S = this.attributes.State;
            data.SA = this.attributes.StateAbbreviation;
            data.STID = this.attributes.StateID;
            data.ZID = this.attributes.ZipCodeID;
            data.Z = this.attributes.ZipCode;
            data.CID = this.attributes.CountryID;
            data.PH = this.attributes.PhoneNumber;
            data.SD = this.attributes.ShortDescription;
            data.D = this.attributes.Description;
            if (this.attributes.PhotoURL)
            data.PU = getImageFileName(this.attributes.PhotoURL);
            data.TZID = this.attributes.TimeZoneID;
            data.LLDT = this.attributes.LastLoginDT;
            data.CDT = this.attributes.CreatedDT;
            data.RUID = this.attributes.ReferredByUserID;
            data.N = this.attributes.notifications;
            data.NT = this.attributes.network;
            data.IE = this.attributes.IsEditable;
            data.P = this.attributes.Primary;
            data.SQ = this.attributes.SecurityQuestions;
            data.HC = this.attributes.HasChanged;
            data.DOB = this.attributes.DOB;
            data.MBL = this.attributes.Mobile;
            data.CT = this.attributes.CardType;
            data.SSN4 = this.attributes.SSN4;
            //data.USA = this.attributes.UserSettingAttributes;
            data.SFCS = true;
            data.SMS = this.attributes.SMS;
            data.OIWP = this.attributes.OIWP;

            this.attributes = data;

            return Backbone.Model.prototype.save.call(this, attributes, options);
        },

        isValidEmailAddress: function (emailAddress) {
            var pattern = new RegExp(/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i);
            return pattern.test(emailAddress);
        },
        validation: {
            FirstName: {
                required: true,
                msg: "Please provide a firstname",
                fn: function (value, attr, computedState) {
                    if (value == null || value == "") {
                        return "Please provide a firstname";
                    }
                }
            },
            MiddleName: {
                required: false
            },
            LastName: {
                required: true,
                msg: "Please provide a lastname"
            },
            Email: {
                required: true,
                pattern: "email",
                msg: sysText['FV']['invalid']['email'],
                fn: function (value, attr, computedState) {
                    if (value == null || value == "") {
                        return sysText['FV']['required']['email'];
                    } else {
                        var cm = computedState.EmailConfirm;
                        if (value != cm) {
                            return sysText['FV']['invalid']['emailsDoNotMatch'];
                        }
                    }
                }
            },
            EmailConfirm: {
                required: true,
                pattern: "email",
                msg: "Please provide a valid email address",
                fn: function (value, attr, computedState) {
                    if (value == null || value == "") {
                        return sysText['FV']['required']['email'];
                    } else {
                        var m = computedState.Email;
                        if (value != m) {
                            return sysText['FV']['invalid']['emailsDoNotMatch'];
                        }
                    }
                }
            },
            Password: {
                required: true,
                minLength: 8,
                msg: sysText['FV']['invalid']['password'],
                fn: function (value, attr, computedState) {
                    if (value == null || value == "") {
                        return sysText['FV']['invalid']['password'];
                    } else {
                        var cp = computedState.PasswordConfirm;
                        if (value != cp) {
                            return sysText['FV']['invalid']['passwordsDoNotMatch'];
                        }
                    }
                }
            },
            PasswordConfirm: {
                required: true,
                minLength: 8,
                msg: sysText['FV']['invalid']['password'],
                fn: function (value, attr, computedState) {
                    if (value == null || value == "") {
                        return sysText['FV']['invalid']['password'];
                    } else {
                        var cm = computedState.Password;
                        if (value != cm) {
                            return sysText['FV']['invalid']['passwordsDoNotMatch'];
                        }
                    }
                }
            },
            SSN:{
                required: this.ssnRequired,
                //minLength: 9,
                msg: sysText['FV']['required']['ssnTaxID'],
                fn: function (value, attr, computedState) {
                    if (value == null || value == "") {
                        return sysText['FV']['required']['ssnTaxID'];
                    }
                }
            },
            ZipCode: {
                fn: function (value, attr, computedState) {
                    if (value != null || value != "") {
                        var errmsg;
                        $.ajax({
                            type: 'GET',
                            async: false,
                            url: pf.lookupsURL + "/ZipCodes/" + value,
                            contentType: "application/json",
                            success: function () {
                            },
                            error: function () {
                                errmsg = sysText['FV']['invalid']['zipCode'];
                            }
                        });
                        return errmsg;
                    }

                }
            },
            Gender: {
                required: false,
                msg: sysText['FV']['required']['gender'],
            },
            //City: {
            //    required: false
            //},
            //State: {
            //    required: false
            //},
            Cell: {
                required: false
            },
        }

    });

    return User;
});

